
import api from "../../../api/api";

export const copyCourseContentApi = async ({
  payload,
  token,
}) => {
  const response = await api.post(
    "/courses/copy-content/",
    payload,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return response.data;
};

export const duplicateLessonsApi = async (payload, token) => {
  const response = await api.post(
    "/courses/copy-content/",
    payload,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return response.data;
};